<template>
  <div>
    <modal :show="true">
      <template slot="header">
        <h5 class="modal-title" id="label">{{ $t('editfacilitatorname') }}</h5>
      </template>

      {{ $t('description') }}
      <br />
      <br />
      <br />

      <div class="alert alert-primary" role="alert" v-if="alertMessage">{{ $t(alertMessage) }}</div>

      <div>
        <small class="text-uppercase font-weight-bold">{{ $t('firstname') }}</small>
        <base-input
          maxLength="30"
          id="input-firstname"
          v-model="firstName"
          class="mb-3"
          v-bind:placeholder="$t('firstname')"
        />
      </div>
      <div>
        <small class="text-uppercase font-weight-bold">{{ $t('lastname') }}</small>
        <base-input
          maxLength="50"
          id="input-lastname"
          v-model="lastName"
          class="mb-3"
          v-bind:placeholder="$t('lastname')"
        />
      </div>
      <template slot="footer">
        <base-button type="primary" @click="save()" :disabled="disableSubmit">{{$t('save')}}</base-button>
      </template>
    </modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { changeFacilitatorName } from "../services/APIService";

export default {
  props: ["editplayer"],
  data() {
    return {
      firstName: "",
      lastName: "",
      alertMessage: null
    };
  },
  computed: {
    disableSubmit() {
      return !(this.firstName.length && this.lastName.length);
    }
  },
  methods: {
    save() {
      changeFacilitatorName(this.firstName, this.lastName)
        .then(() => {
          this.$router.push("/admin/games");
        })
        .catch(error => {
          this.alertMessage = "errorsaving";
        });
    }
  }
};
</script>

<i18n>
{
"en": {
    "firstname": "* First name",
    "lastname": "* Last name",
    "save": "Save",
    "errorsaving": "Error saving changes",
    "editfacilitatorname": "Please enter your name",
    "description": "You have logged in for the first time - Welcome to SmoothTeam! Please enter your name."
  },
  "fi": {
    "firstname": "* Etunimi",
    "lastname": "* Sukunimi",
    "save": "Tallenna",
    "errorsaving": "Muutosten tallentaminen epäonnistui",
    "editfacilitatorname": "Anna nimesi",
    "description": "Kirjauduit ensimmäistä kertaa - tervetuloa SmoothTeamiin! Kerrothan vielä nimesi."
  },
"sv": {
    "firstname": "* Förnamn",
    "lastname": "* Efternamn",
    "save": "Spara",
    "errorsaving": "Fel i när ändrigarna skulle sparas",
    "editfacilitatorname": "Vänligen fyll i ditt namn",
    "description": "Du har loggat in för första gången - Välkommen till SmoothTeam! Vänligen fyll i ditt namn."
  },
"de": {
    "firstname": "* Vorname",
    "lastname": "* Nachname",
    "save": "Speichern",
    "errorsaving": "Fehler beim Speichern der Änderungen",
    "editfacilitatorname": "Bitte geben Sie Ihren Namen ein",
    "description": "Sie haben sich zum ersten Mal angemeldet - Willkommen bei SmoothTeam! Bitte geben Sie Ihren Namen ein."
  },
  "ko": {
    "firstname": "* 이름",
    "lastname": "* 성",
    "save": "저장",
    "errorsaving": "Error saving changes",
    "editfacilitatorname": "이름을 입력해주십시오.",
    "description": "Smooth Team 에 오신 것을 환영합니다. 이름을 입력해주십시오."
  }
}
</i18n>
